"use client";
import { hometestimonials, testimonials } from "@/data/testimonials";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import Link from "next/link";
export default function EmployeeMainFeatures() {
  return (
    <div className="container position-relative">
      <div className="pt-80 pb-80 pt-sm-70 pb-sm-70 px-4 bg-gray-light-1">
        <div className="row">
          <div className="col-lg-12 -offset-lg-1 wow fadeInUp">
            <div className="row">
              <div className="col-md-10 offset-md-1 text-center">
                <h2 className="section-title mb-70 mb-sm-40">
                  {/* GetBiz Solutions is trusted by &nbsp;
                  <span className="mark-decoration-1">10,000+</span>
                  &nbsp;customers. */}
                  Key Highlights of Our HR System
                </h2>
              </div>
            </div>
            <div className="overflow-hidden">
              <Swiper
                rewind
                spaceBetween={0}
                slidesPerView={1}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".snbp2",
                  nextEl: ".snbn2",
                }}
                watchSlidesProgress
                resizeObserver
                style={{
                  opacity: 1,
                  display: "block",
                }}
                className="testimonials-slider-1 owl-carousel owl-theme pb-xs-80 overflow-visible position-static"
              >
                {/* {hometestimonials.map((testimonial, index) => (
                  <SwiperSlide className="owl-item" key={index}>
                    <div>
                      <blockquote className="mb-0">
                        <div className="blockquote-icon" aria-hidden="true">
                          ”
                        </div>
                        <p>{testimonial.quote}</p>
                        <div className="section-line mt-40" />
                        <footer className="ts1-author mt-20 clearfix">
                          <div className="overflow-hidden">
                            {testimonial.author}
                            <div className="small">{testimonial.role}</div>
                          </div>
                        </footer>
                      </blockquote>
                    </div>
                  </SwiperSlide>
                ))} */}
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={1200}
                          height={700}
                          src="/assets/images/img/product/hrms/employeems/attendance_tracking.webp"
                          // src="/assets/images/services-image.jpg"
                          className="image-fullwidth relative"
                          alt="Image Description"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/employee-management-system/attendance-tracking">
                            <h3 className="h3">Attendance Tracking</h3>
                          </Link>

                          <p className="text-gray">
                            Manage work hours efficiently with real-time updates, ensuring accurate tracking of attendance, overtime, and breaks.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Clock-In/Out
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Overtime Tracking
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Break Management
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Real-Time Updates
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={1200}
                          height={700}
                          src="/assets/images/img/product/hrms/employeems/emp_directory.webp"
                          className="image-fullwidth relative"
                          alt="Image Description"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/employee-management-system/employee-directory">
                            <h3 className="h3">Employee Directory</h3>
                          </Link>
                          <p className="text-gray">
                            Keep all employee data securely stored and easily accessible, including profiles, documents, and role assignments.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Profile Creation
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Document Uploads
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Role Assignments
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Secure Storage
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>


                <div className="owl-controls clickable">
                  {/* <div className="owl-pagination">
                    <div className="owl-page">
                      <span className=""></span>
                    </div>
                    <div className="owl-page active">
                      <span className=""></span>
                    </div>
                  </div> */}
                  {/* owl-buttons */}
                  <div className=" text-center">
                    <div className="owl-prev snbp2" role="button" tabIndex="0">
                      <span className="visually-hidden">Previous Slide</span>
                      <i className="mi-arrow-left" aria-hidden="true"></i>
                    </div>
                    <div className="owl-next snbn2" role="button" tabIndex="0">
                      <span className="visually-hidden">Next Slide</span>
                      <i className="mi-arrow-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                {/* End Slide Item */}
              </Swiper>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
